module.exports = __webpack_public_path__ + "img/icon-healthplan-inactive.7bc6d0fa.png";